import React from "react";
import ReactModal from "react-modal";
import "./set-goal-modal.scss";
import { Formik } from "formik";
import { Col, Form } from "react-bootstrap";
import Cleave from "cleave.js/react";
import * as yup from "yup";
import { saveGoals } from "../../../api";
import SelectDropDown from "../../shared/drop-down/drop-down";

const schema = yup.object({
    submitting_apps: yup.number().required("* Submitting apps required"),
    approved_apps: yup.number().required("* Daily approved apps required"),
    monthly_volume: yup.number().required("* Monthly volume required"),
});

class SetGoalModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            goalData: {
                submitting_apps: this.props.agentGoalData.submitting_apps,
                approved_apps: this.props.agentGoalData.approved_apps,
                monthly_volume: this.props.agentGoalData.monthly_volume,
                goalUser: "agent",
            },
            goalUser: null,
            errors: null,
            is_submitted: false,
        };
    }

    handleSetGoalSubmit = () => {
        saveGoals(this.state.goalData)
            .then((res) => {
                this.props.closeModal();
                this.props.getUpdatedUser();
            })
            .catch((err) => {});
    };

    updateChange(event) {
        const targetName = event.target.name;
        if (targetName === "") {
            return false;
        }
        let goalData = this.state.goalData;
        goalData[targetName] = event.target.value;

        this.setState({ goalData: goalData });
    }

    render() {
        let { is_submitted, goalData } = this.state;
        return (
            <ReactModal isOpen={this.props.show} className="set-goal-modal">
                <div className="modal-header">
                    <h4 className="text-left">Set your daily goal</h4>
                </div>
                <div className="modal-cancel" onClick={this.props.closeModal}>
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-body">
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.handleSetGoalSubmit(e)}
                        initialValues={this.state.goalData}
                        initialErrors={this.state.errors}
                        validateOnBlur={false}
                        validateOnChange={is_submitted}
                        validate={(values) => {
                            this.setState({ is_submitted: true });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <Form
                                id="set-goal-form"
                                onSubmit={handleSubmit}
                                onChange={(e) => this.updateChange(e)}
                                autoComplete="off"
                            >
                                <Form.Row>
                                    {this.props.user.role == "admin" && (
                                        <>
                                            <Form.Group
                                                className="px-3 modal-pd"
                                                as={Col}
                                                xs={6}
                                                lg={6}
                                                controlId="goal_user"
                                            >
                                                <button
                                                    className="btn btn-primary btn-block"
                                                    onClick={() => {
                                                        this.setState({
                                                            goalUser: "agent",
                                                            errors: null,
                                                            goalData: {
                                                                submitting_apps:
                                                                    this.props
                                                                        .agentGoalData
                                                                        .submitting_apps,
                                                                approved_apps:
                                                                    this.props
                                                                        .agentGoalData
                                                                        .approved_apps,
                                                                monthly_volume:
                                                                    this.props
                                                                        .agentGoalData
                                                                        .monthly_volume,
                                                                goalUser:
                                                                    "agent",
                                                            },
                                                        });
                                                    }}
                                                    type="button"
                                                >
                                                    Agent
                                                </button>
                                            </Form.Group>
                                            <Form.Group
                                                className="px-3 modal-pd"
                                                as={Col}
                                                xs={6}
                                                lg={6}
                                                controlId="goal_user"
                                            >
                                                <button
                                                    className="btn btn-success btn-block"
                                                    type="button"
                                                    onClick={() => {
                                                        this.setState({
                                                            goalUser: "org",
                                                            errors: null,
                                                            goalData: {
                                                                submitting_apps:
                                                                    this.props
                                                                        .orgGoalData
                                                                        .submitting_apps,
                                                                approved_apps:
                                                                    this.props
                                                                        .orgGoalData
                                                                        .approved_apps,
                                                                monthly_volume:
                                                                    this.props
                                                                        .orgGoalData
                                                                        .monthly_volume,
                                                                goalUser: "org",
                                                            },
                                                        });
                                                    }}
                                                >
                                                    Organisation
                                                </button>
                                            </Form.Group>
                                        </>
                                    )}

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        className="px-3 modal-pd rev-tier"
                                    >
                                        <Cleave
                                            options={{
                                                numericOnly: true,
                                                blocks: [10],
                                            }}
                                            placeholder="Submitting Apps"
                                            name="submitting_apps"
                                            value={values.submitting_apps}
                                            onChange={handleChange}
                                            type="text"
                                            className={`preapp-form-input form-control ${
                                                is_submitted &&
                                                !errors.submitting_apps &&
                                                "is-valid"
                                            } ${touched.submitting_apps && !!errors.submitting_apps && "is-invalid"}`}
                                        />
                                        <label className="modal-lab">
                                            Submitting Apps
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.submitting_apps}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        className="px-3 modal-pd rev-tier"
                                    >
                                        <Cleave
                                            options={{
                                                numericOnly: true,
                                                blocks: [10],
                                            }}
                                            placeholder="Approved Apps"
                                            name="approved_apps"
                                            value={values.approved_apps}
                                            onChange={handleChange}
                                            type="text"
                                            className={`preapp-form-input form-control ${
                                                is_submitted &&
                                                !errors.approved_apps &&
                                                "is-valid"
                                            } ${touched.approved_apps && !!errors.approved_apps && "is-invalid"}`}
                                        />
                                        <label className="modal-lab">
                                            Approved Apps
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.approved_apps}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        className="px-3 modal-pd rev-tier"
                                    >
                                        <Cleave
                                            options={{
                                                numericOnly: true,
                                                blocks: [10],
                                            }}
                                            placeholder="Monthly Volume"
                                            name="monthly_volume"
                                            value={values.monthly_volume}
                                            onChange={handleChange}
                                            type="text"
                                            className={`preapp-form-input form-control ${
                                                is_submitted &&
                                                !errors.monthly_volume &&
                                                "is-valid"
                                            } ${touched.monthly_volume && !!errors.monthly_volume && "is-invalid"}`}
                                        />
                                        <label className="modal-lab">
                                            Monthly Volume
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.monthly_volume}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        )}
                    </Formik>
                </div>
                <div className="modal-footer">
                    <button
                        form="set-goal-form"
                        type="submit"
                        className="btn confirm-button"
                    >
                        {" "}
                        Save{" "}
                    </button>
                    <button
                        className="btn cancel-button"
                        onClick={this.props.closeModal}
                    >
                        {" "}
                        Cancel{" "}
                    </button>
                </div>
            </ReactModal>
        );
    }
}

export default SetGoalModal;
